import { render, staticRenderFns } from "./FIle.vue?vue&type=template&id=484d219d&scoped=true&"
import script from "./FIle.vue?vue&type=script&lang=js&"
export * from "./FIle.vue?vue&type=script&lang=js&"
import style0 from "./FIle.vue?vue&type=style&index=0&id=484d219d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d219d",
  null
  
)

export default component.exports